import { useMemo } from "react";
import {
  Breadcrumb,
  DownloadExcel,
  ErrorAlert,
  GiftIcon,
  ImportData,
  LinkBtn,
  PageHero,
  SearchToggle,
  TableRowsPerPage,
  useCanShow,
  useDelete,
  useFetchData,
  useSearch,
  useToggle,
} from "@";
import { DataTable } from "@/shared/components/tanstackTable";
import MultiSearch from "./components/MultiSearch";
import { excelHeaderCellsName, searchValues } from "./utils/options";
import { TableActions, tableColumns } from "./components/TableOptions";
import { getGiftProjects, toggleActive, toggleArchive } from "./utils/api";

const Index = () => {
  const links = [{ name: "الإهداءات" }];

  const { search, updateSearch } = useSearch(searchValues);

  const { data, setData, isLoading, error, pg, fetchData, updatePg } =
    useFetchData({
      fun: getGiftProjects,
      params: [search.values],
    });

  const { deleteHandler } = useDelete(data, setData, "giftProjects");
  const { active, archive } = useToggle(setData, toggleActive, toggleArchive);

  // Append actions column
  const columns = useMemo(
    () => [
      ...tableColumns,
      {
        id: "actions",
        header: "خيارات",
        size: 200,
        cell: ({ row }) => (
          <TableActions
            row={row.original}
            ToggleActive={active}
            ToggleArchive={archive}
            deleteHandler={deleteHandler}
          />
        ),
      },
    ],
    [active, archive, deleteHandler],
  );

  return (
    <>
      <ErrorAlert reload={fetchData} show={error} />
      <Breadcrumb links={links} />

      <main className="table-card relative">
        <PageHero
          eyebrow="الإهداءات"
          title="الإهداءات"
          count={data?.length}
          icon={GiftIcon}
          hideCount={isLoading}
        >
          <TableRowsPerPage
            pagination={pg}
            rowsPerPageOptions={[5, 10, 15, 25]}
            onRowsPerPageChange={(size) => updatePg({ size })}
          />

          <DownloadExcel
            pageSize=""
            length={data?.length}
            search={search.values}
            fetch={getGiftProjects}
            headerCellsName={excelHeaderCellsName}
            logExport={{ action: 1, description: "تصدير الإهداءات" }}
          />

          {useCanShow("editGiftProject") && (
            <LinkBtn to="/giftProjects/create" create />
          )}

          <ImportData success={fetchData} to="giftProject" />
          <SearchToggle toggle={() => updateSearch({ show: !search.show })} />
        </PageHero>

        <MultiSearch
          search={search}
          onSubmit={fetchData}
          updateSearch={updateSearch}
        />

        <DataTable
          data={data}
          columns={columns}
          isLoading={isLoading}
          pagination={pg}
          onPageChange={(page) => updatePg({ page })}
          onPageSizeChange={(size) => updatePg({ size, page: 1 })}
        />
      </main>
    </>
  );
};

export default Index;
